'use strict';

var _ = require('lodash');
var PaxGridService = function PaxGridService($filter, configurationService, optWeekService) {
  function getCellColors(value, colorMap) {
    for (var i = 0, length = colorMap.length; i < length; i++) {
      if ((value >= colorMap[i].start || colorMap[i].start === undefined) && (value <= colorMap[i].end || colorMap[i].end === undefined)) {
        return colorMap[i];
      }
    }
    return {};
  }
  function getTooltipData(tooltipConfig, row, columns) {
    var tooltip = {
      fields: []
    };
    if (tooltipConfig.title === undefined) {
      tooltip.title = false;
    } else {
      tooltip.title = tooltipConfig.title;
    }
    columns.forEach(function (column) {
      if (tooltipConfig.fields.indexOf(column.field) !== -1) {
        tooltip.fields.push({
          label: column.label,
          value: row[column.field]
        });
      }
    });
    return tooltip;
  }
  function getSortedRow(sourceRow, columns, colorMap, rowSpanField, rowSpan) {
    var sortedRow = [];
    columns.forEach(function (column) {
      var cell = {
        value: sourceRow[column.field]
      };

      //hack to prevent table layout crash if column is empty
      if (_.isUndefined(cell.value)) {
        cell.value = '&nbsp;';
      } else {
        column.isEmpty = false;
      }
      if (column.type === 'date' && !_.isUndefined(column.format)) {
        cell.value = $filter('rmMomentFormat')(sourceRow[column.field], column.format);
      }
      if (column.field === rowSpanField) {
        cell.isGroupBy = true;
        if (rowSpan) {
          cell.rowSpan = rowSpan;
        }
      }
      if (column.tooltip !== undefined) {
        cell.tooltip = getTooltipData(column.tooltip, sourceRow, columns);
      }
      if (column.title !== undefined) {
        cell.title = cell.value;
      }
      if (colorMap && typeof cell.value === 'number') {
        var colors = getCellColors(cell.value, colorMap);
        cell.colors = {
          backgroundColor: colors.backgroundColor,
          color: colors.color
        };
      }
      if (column.ellipsis !== undefined) {
        var regex = column.ellipsis.split('/');
        regex = new RegExp(regex[1], regex[2]);
        regex = regex.exec(cell.value);
        if (regex !== null) {
          cell.value = regex[1] + '...';
        }
      }
      sortedRow.push(cell);
    });
    return sortedRow;
  }
  var groupByOptWeek = function groupByOptWeek(sourceData) {
    var sortedWeek = optWeekService.getDaysOfWeek().map(function (day) {
      return day.toUpperCase();
    });
    var sortedData = {};
    for (var i = 0; i < sortedWeek.length; i++) {
      var day = sortedWeek[i];
      sortedData[day] = [];
    }
    for (var j = 0, sourceDataLength = sourceData.length; j < sourceDataLength; j++) {
      var element = sourceData[j];
      var elementDay = findDayNameMatch(sortedWeek, element.dow.toUpperCase());
      sortedData[elementDay].push(element);
    }
    return sortedData;
  };
  function findDayNameMatch(sortedWeek, elementDay) {
    var dow;
    if (sortedWeek.indexOf(elementDay) !== -1) {
      dow = elementDay;
    } else {
      for (var i = 0; i < sortedWeek.length; i++) {
        if (sortedWeek[i].length > elementDay.length) {
          if (_.startsWith(sortedWeek[i], elementDay)) {
            dow = sortedWeek[i];
            break;
          }
        }
        if (sortedWeek[i].length < elementDay.length) {
          if (_.startsWith(elementDay, sortedWeek[i])) {
            dow = sortedWeek[i];
            break;
          }
        }
      }
    }
    return dow;
  }
  var groupByDaysToDepartureRange = function groupByDaysToDepartureRange(sourceData) {
    var startingDayRange = sourceData.map(function (item) {
      return item.daysToDeparture;
    });
    var sortedDateRanges = startingDayRange.sort(compareDayRanges);
    var sortedData = {};
    for (var i = 0; i < sortedDateRanges.length; i++) {
      var dateRange = sortedDateRanges[i];
      sortedData[dateRange] = [];
    }
    for (var j = 0, sourceDataLength = sourceData.length; j < sourceDataLength; j++) {
      var element = sourceData[j];
      var daysToDeparture = element.daysToDeparture;
      sortedData[daysToDeparture].push(element);
    }
    return sortedData;
  };
  function compareDayRanges(r1, r2) {
    var a = r1.split('-')[0];
    var b = r2.split('-')[0];
    return a - b;
  }
  var orderBy = function orderBy(collection, options) {
    return _.forEach(collection, function (element, groupName) {
      return _.orderBy(collection[groupName], options.fields, options.orders);
    });
  };
  var sort = function sort(sourceData, groupBy, rowSpanField) {
    var sorted;
    var options = {
      fields: [],
      orders: []
    };
    var groupingApplied;
    groupBy.map(function (element) {
      if (element.field === 'dow' && element.startFromOptWeek) {
        sorted = groupByOptWeek(sourceData);
        groupingApplied = true;
      } else if (element.field === 'daysToDeparture') {
        sorted = groupByDaysToDepartureRange(sourceData);
        groupingApplied = true;
      } else {
        options.fields.push(element.field);
        options.orders.push(element.direction);
      }
    });
    if (groupingApplied) {
      return orderBy(sorted, options);
    } else if (rowSpanField) {
      var grouped = _.groupBy(sourceData, rowSpanField);
      return orderBy(grouped, options);
    } else {
      return _.orderBy(sourceData, options.fields, options.orders);
    }
  };
  function prepareRowsForGroupBy(columns, sourceData, colorMap, sortConfig, rowSpanField) {
    var grouped = sort(sourceData, sortConfig, rowSpanField);
    if (colorMap || rowSpanField) {
      var rows = [];
      _.forEach(grouped, function (rowsInGroup, groupName) {
        _.forEach(rowsInGroup, function (row, idx) {
          var preparedRow;
          if (rowSpanField) {
            var rowSpan = idx === 0 ? grouped[groupName].length : undefined;
            preparedRow = getSortedRow(row, columns, colorMap, rowSpanField, rowSpan);
          } else {
            preparedRow = getSortedRow(row, columns, colorMap);
          }
          rows.push(preparedRow);
        });
      });
      return rows;
    } else {
      return grouped;
    }
  }
  function resetEmptyColumnFlag(column) {
    column.isEmpty = true;
  }
  function formatData(columns, sourceData, colorMap, sortConfig, rowSpanField) {
    _.each(columns, resetEmptyColumnFlag);
    if (Array.isArray(sortConfig) && sortConfig.length > 0 || rowSpanField) {
      return prepareRowsForGroupBy(columns, sourceData, colorMap, sortConfig, rowSpanField);
    }
    return sourceData.map(function (sourceRow) {
      return getSortedRow(sourceRow, columns, colorMap);
    });
  }
  return {
    formatData: formatData
  };
};
PaxGridService.$inject = ['$filter', 'ConfigurationService', 'OptWeekService'];
module.exports = PaxGridService;